// Experiment release toggles
export const EXPERIMENT_NAME_RELEASE_SWITCH_TOGGLE = 'release-switch'
export const EXPERIMENT_NAME_RELEASE_TOGGLE_VARIANT_MARKETPLACE = 'marketplace'
export const EXPERIMENT_NAME_RELEASE_TOGGLE_VARIANT_NOW = 'now'
export const EXPERIMENT_NAME_ODS_VC_MODAL = 'wsssh-188'
export const EXPERIMENT_NAME_ERX_ADYEN_MP = 'erx-adyen-mp'
export const EXPERIMENT_NAME_HOME_ONE_ACCOUNT = 'wsssh-2348'
export const EXPERIMENT_NAME_ADVERTISING_FLYOUT_BANNER = 'cro-1333'
export const EXPERIMENT_NAME_NEW_CDN = 'cro-1881'
export const EXPERIMENT_NAME_PDP_DELIVERY_OPTIONS = 'nowcj-2'
export const EXPERIMENT_NAME_ACCOUNT_OVERVIEW_REDPOINTS_WIDGET = 'wscnl-7291'
export const EXPERIMENT_NAME_ACCOUNT_OVERVIEW_NOTEPAD_WIDGET = 'wscnl-7438'
export const EXPERIMENT_NAME_SINGLE_ITEM_CANCELLATION = 'wstra-8615'
export const EXPERIMENT_NAME_CONTACT_PAGE_ACCOUNT_MANAGEMENT_DIALOG =
  'wscnl-9358'
export const EXPERIMENT_NAME_DIRECT_CONTACT_FORM_DIALOG = 'wscnl-9487'
export const EXPERIMENT_NAME_CONTACT_PAGE_REDESIGN = 'pdcil-799'
export const EXPERIMENT_NAME_HEADER_MOBILE_ICON_LIST = 'wscnl-8443'
export const EXPERIMENT_NAME_AD_SERVER = 'ad-server'
export const EXPERIMENT_NAME_CART_INTERMEDIATE_DRAWER = 'wscr-3424'
export const EXPERIMENT_NAME_DISCOUNT_REMOVAL_FR = 'cro-4200'
export const EXPERIMENT_NAME_HELP_CENTER_SELF_SERVICES = 'wscnl-9564'
export const EXPERIMENT_NAME_PERSONAL_ADVICE_DIALOG = 'wscnl-9727'
export const EXPERIMENT_NAME_FULLSTORY_TRACKING = 'pdcil-723'
export const EXPERIMENT_NAME_COMPETERA = 'cro-5727'
export const EXPERIMENT_STRONGER_PASSWORD_ENFORCEMENT = 'wscnl-10597'
export const EXPERIMENT_NAME_AD_SERVER_TOP_ALGOLIA_RESULTS = 'rmadt-3482'
export const EXPERIMENT_CHANGE_GTM_SCRIPT = 'cro-4910'
export const EXPERIMENT_NAME_RATEPAY_BUYER_PORTAL = 'wstra-12561'
export const EXPERIMENT_NAME_HOME_CROSSSELL_INJECTION =
  'ad-exp-homepage-cro5909'
